<template>
  <img
    :src="image"
    class="draggable ios-fix"
    :class="`puzzle-${target}`"
    ref="el"
    :data-startx="startPos.x"
    :data-starty="startPos.y"
    :data-target="target"
  />
</template>
<script setup>
import interact from 'interactjs'
import { ref, onMounted } from 'vue'

const props = defineProps(['image', 'target', 'active'])
const el = ref(null)
const startPos = ref({})

const handleResize = () => {
  var rect = interact.getElementRect(el.value)
  startPos.value = {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2
  }
}

onMounted(() => {
  var rect = interact.getElementRect(el.value)
  startPos.value = {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2
  }

  window.addEventListener('resize', handleResize)

  interact(el.value).draggable({
    restrict: {
      restriction: '.gameboard'
    },
    snap: {
      targets: [startPos.value],
      range: Infinity,
      relativePoints: [{ x: 0.5, y: 0.5 }],
      endOnly: true
    },
    onstart: function (event) {
      let el = event.target
      let arr = Array.from(el.classList)

      if (!arr.includes('dropped')) {
        event.interactable.draggable({
          snap: {
            targets: [startPos.value]
          }
        })
      }
    },
    onmove: function (event) {
      var target = event.target,
        x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
        y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      let arr = Array.from(target.classList)

      if (!arr.includes('dropped') && props.active) {
        target.style.webkitTransform = target.style.transform =
          'translate(' + x + 'px, ' + y + 'px)'

        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
      }
    }
  })
})

onMounted(() => {})
</script>
<style>
.ios-fix {
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
</style>
